import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

const propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

const AlbumSlideshowGridViewerActionButton = ({
  className,
  tooltipId,
  label,
  icon,
  onClick,
  ...props
}) => {
  const classes = classNames({
    'slideshow-grid-viewer-action-button': true,
    [className]: !!className,
  });

  return (
    <button
      data-tip
      className={classes}
      data-for={tooltipId}
      data-position="bottom"
      onClick={onClick}
      {...props}
    >
      <span className="sr-only">{label}</span>
      {icon}
      <ReactTooltip id={tooltipId} className="tooltip">
        {label}
      </ReactTooltip>
    </button>
  );
};

AlbumSlideshowGridViewerActionButton.propTypes = propTypes;

export default AlbumSlideshowGridViewerActionButton;
